/* =====================================================================
   Statistiche dell'aroma - 29 AGO 2026

   COSA FA
   Accende i pallini giusti quando la finestra dell'aroma cambia gusto.
   Niente altro: il disegno e le parole li ha gia messi lo snippet, e i
   numeri li ha gia scritti Shopify dentro l'attributo data-valori.

   COME CAPISCE QUALE AROMA E' APERTO
   Non tiene un suo contatore, perche' due contatori che devono restare
   uguali prima o poi non lo sono piu. Legge invece quello che la
   finestra sta mostrando in questo momento - il nome, e in seconda
   battuta l'indirizzo dell'immagine - e lo cerca fra le schede degli
   aromi della pagina, che portano gia scritto il codice del prodotto.
   Se il nome un giorno cambia o viene tradotto, cambia in tutti e due i
   posti insieme, quindi il collegamento regge da solo.

   PERCHE' UN OSSERVATORE E NON UN CLICK
   La finestra cambia gusto in tre modi: click sull'aroma, frecce,
   tastiera. Un osservatore li copre tutti e tre senza doverli conoscere.
   Non entra in circolo perche' guarda solo testo e immagine, mentre
   questo file scrive soltanto numeri sulle colonne.

   SE UN AROMA NON E' IN TABELLA
   Le tre colonne spariscono per quell'aroma. E' voluto: meglio niente
   che tre pallini a caso.
   ===================================================================== */
(function () {
  var blocco = document.querySelector('[data-ab-stats]');
  if (!blocco) return;

  var dati;
  try {
    dati = JSON.parse(blocco.getAttribute('data-valori') || '{}');
  } catch (e) {
    return;
  }

  var colonne = blocco.querySelectorAll('[data-ab-stats-colonna]');
  if (colonne.length !== 3) return;

  /* ------------------------------------------------------------------
     Rubrica: dal nome (o dall'immagine) al codice del prodotto. La
     costruiamo una volta sola dalle schede degli aromi gia in pagina.
     ------------------------------------------------------------------ */
  var perNome = {};
  var perImmagine = {};
  var schede = document.querySelectorAll('.flavor[data-product-id]');

  for (var i = 0; i < schede.length; i++) {
    var scheda = schede[i];
    /* la finestra stessa non e' una scheda */
    if (scheda.closest && scheda.closest('#flavor-modal')) continue;

    var codice = scheda.getAttribute('data-product-id');
    if (!codice || !dati[codice]) continue;

    var nome = (scheda.getAttribute('data-name') || '').trim();
    var immagine = scheda.getAttribute('data-image') || '';
    if (nome) perNome[nome] = codice;
    if (immagine) perImmagine[immagine] = codice;
  }

  var titolo = document.querySelector('.flavor-modal-highlight');
  var figura = document.querySelector('.flavor-modal-image');
  var ultimo = ' ';

  function codiceMostrato() {
    if (titolo) {
      var nome = (titolo.textContent || '').trim();
      if (perNome[nome]) return perNome[nome];
    }
    if (figura) {
      var src = figura.getAttribute('src') || '';
      if (perImmagine[src]) return perImmagine[src];
    }
    return '';
  }

  function disegna() {
    var codice = codiceMostrato();
    if (codice === ultimo) return;
    ultimo = codice;

    var valori = dati[codice];
    if (!valori || valori.length !== 3) {
      blocco.setAttribute('hidden', '');
      return;
    }

    blocco.removeAttribute('hidden');
    for (var i = 0; i < 3; i++) {
      colonne[i].setAttribute('data-livello', valori[i]);
    }
  }

  var finestra = document.getElementById('flavor-modal');
  if (finestra && window.MutationObserver) {
    new MutationObserver(disegna).observe(finestra, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['src']
    });
  }

  disegna();
})();
